import richTextFragment from '@components/renderers/rich-text.fragment'

const reRegisterFragment = `
  metaDataField
  metaImage {
    url
  }
  metaDescription
  heroImage {
    url
    description
  }
  heroImageMobile {
    url
    description
  }
  headline
  subtitle
  breadcrumbsCollection(limit: 5) {
    items {
      buttonLabel
      buttonLink
    }
  }
  ctaHeadline
  ctaButtonOne
  ctaButtonTwo
  ctaDescription
  ctaLinkText
  ctaLink
  bodyRichText {
    ${richTextFragment}
  }
  promptBlockSection {
    heading
    subtitle
    supportiveCopy
    buttonLabel
    buttonLink
  }
  marketingEmailForm {
    headline
    digiohFormId
  }
`

export default reRegisterFragment
